"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pragma = require("../../../../pragma");

var _react = _interopRequireWildcard(require("react"));

var _ = require("../../..");

var _Video = _interopRequireDefault(require("../Video/Video"));

var css = _interopRequireWildcard(require("./MediaStory.style"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const MediaStory = props => {
  const {
    story,
    isPaused,
    isLoaded,
    hasMediaError,
    onPlay,
    onPause,
    onChangeVideoDuration,
    onMediaLoaded,
    onError
  } = props;
  const [muted, setMuted] = (0, _react.useState)(true);

  const handleMute = () => setMuted(true);

  const handleUnmute = () => setMuted(false);

  const getStoryComponent = () => {
    const image = (0, _pragma.createFelaElement)("img", {
      alt: "Story",
      src: story.url,
      css: css.image,
      onLoad: onMediaLoaded,
      onError: onError
    });

    switch (story.type) {
      case 'video':
        return (0, _pragma.createFelaElement)(_Video.default, {
          story: story,
          isPaused: isPaused,
          isLoaded: isLoaded,
          isMuted: muted,
          onMediaLoaded: onMediaLoaded,
          onChangeVideoDuration: onChangeVideoDuration,
          onPause: onPause,
          onPlay: onPlay,
          onMute: handleMute,
          onUnmute: handleUnmute,
          onError: onError
        });

      case 'image':
        return image;

      default:
        return image;
    }
  };

  const media = hasMediaError ? (0, _pragma.createFelaElement)(_.Text, {
    size: "l",
    weight: "semiBold",
    color: "text.3"
  }, "Can not load media") : getStoryComponent();
  return (0, _pragma.createFelaElement)(_.View, {
    justifyContent: "center",
    alignItems: "center",
    css: css.wrapper
  }, media, !isLoaded && !hasMediaError && (0, _pragma.createFelaElement)(_.Loading, {
    css: css.loader,
    justifyContent: "center",
    alignItems: "center",
    color: "ui1"
  }));
};

var _default = MediaStory;
exports.default = _default;
//# sourceMappingURL=MediaStory.js.map